import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '@/core-pages/home/HomePage';

export const Route = createFileRoute('/{-$locale}/')({
  component: HomePage,
});
